import { Price, Fiat } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { OrdersQueryParamsCollection } from "./limit-orders-route.interface";
import { IFiatWalletDataViewModel } from "@modules/checkout/entities/checkout.fiat-selection.model";
import { IOrderEstimate, IOrderTotal, IOrdersCreateResponse } from "./limit-orders.remote.interface";
import {
	BUY_ORDERS_PILL_VALUE,
	CANCELLED_ORDERS_PILL_VALUE,
	EXECUTED_ORDERS_PILL_VALUE,
	SELL_ORDERS_PILL_VALUE
} from "@helpers/const/following-options";
import { OrderType } from "@gql/offer";
import { Dictionary } from "@helpers/types";
import { VSNOptinToggleViewModel } from "@modules/web3/interface/web3.benefit.ui.interface";
import { UserJourney } from "@modules/shared/terms-and-conditions/entities/terms-and-conditions.model";

export interface IOrderAmountDataViewModel {
	price: Price;
	fiat: Fiat;
	tradable: Tradable;
	queryParams: Partial<OrdersQueryParamsCollection>;
	buyPower: number;
	isLimitReached: boolean;
}

export interface IOrderAmountSellViewModel {
	price: Price;
	fiat: Fiat;
	tradable: Tradable;
	queryParams: Partial<OrdersQueryParamsCollection>;
	sellPower: number;
	hasError: boolean;
	isLimitReached: boolean;
}

export interface IOderBuyPower {
	buyPower: number;
	minBuy: number;
}

export interface IOrderCurrencySelectionVM {
	query: Partial<OrdersQueryParamsCollection>;
	list: IFiatWalletDataViewModel[];
	totalOrders: Dictionary<Partial<IOrderTotal>>;
}

export interface IOrderReviewState extends IOrderBuyDataState {
	amount: string;
	targetPrice: string;
	estimatedValue: string;
	isTaxable: boolean;
	showSpread: boolean;
	isFeeTransparent: boolean;
	feePercentage: string;
	userJourney: UserJourney[];
	VSNOptinToggleViewModel?: VSNOptinToggleViewModel;
}

export interface IOrderBuyDataState {
	price: Price;
	fiat: Fiat;
	tradable: Tradable;
	walletId: string;
	totalOrders: IOrderTotal[];
	isCashPlus: boolean;
}

export interface IOrderSuccessViewModel extends IOrdersCreateResponse {
	estimate: IOrderEstimate;
	tradable: Tradable;
	fiat: Fiat;
}

export interface IOrderAmountTrackerState {
	amount: number;
}

export enum IOrderListFilterType {
	Buy = BUY_ORDERS_PILL_VALUE,
	Sell = SELL_ORDERS_PILL_VALUE,
	Cancelled = CANCELLED_ORDERS_PILL_VALUE,
	Executed = EXECUTED_ORDERS_PILL_VALUE
}

export interface ICancelOrderPayload {
	orderId: string;
	orderType: OrderType;
	assetPid: string;
}

export enum IOrderSwitchVisibilityType {
	Hidden = "hidden",
	Show_Once = "show once",
	Show_Always = "show always"
}

export enum ISwitchSeenCookie {
	Seen = "seen",
	NotSeen = "not_seen"
}

export interface IOrderDefaultPrice {
	price: Price;
	hasError: boolean;
}
